import { CONTENT_TYPES } from 'constants/games/contentTypes'
import { AchievementButtonCSS } from './AchievementButtonCSS.styled'
import { Link } from 'components/Atoms/Link'

export const AchievementButton = () => {
  return (
    <AchievementButtonCSS>
      <Link to={`/game/${CONTENT_TYPES.ACHIEVEMENT}`} className='header_link' type='button'>
        ACHIEVEMENTS
      </Link>
    </AchievementButtonCSS>
  )
}
